'use client'

import { useNotificationStore } from '@repo/store/useNotificationStore'
import { WarningIcon } from '@repo/ui/WarningIcon'
import MUIButton from '@mui/material/Button'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'

export const ThirdPartyNotification = ({ open }: ThirdPartyNotificationProps) => {
  const { setNotificationDrawerIsOpen, setNotificationSourceId, setNotificationTypeId, fetchAllNotifications } =
    useNotificationStore()

  return (
    <MUIStack
      display="flex"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height="auto"
      width="100%"
      data-testid="ThirdPartyNotification"
      sx={{
        backgroundColor: 'rgba(195, 83, 9, 0.04)',
        border: !open ? 'none' : '1px solid #C35309',
        borderRadius: '0.25rem',
        padding: !open ? '0' : '0.5rem 0.75rem 0.5rem 1rem',
        minHeight: !open ? '0px' : '54px',
        maxHeight: !open ? '0px' : '54px',
        height: !open ? '0px' : '54px',
        transition:
          'border 0.4s ease-in-out, min-height 0.6s ease-in-out, max-height 0.6s ease-in-out, height 0.6s ease-in-out, padding 0.2s ease-in-out',
        overflow: 'hidden'
      }}
    >
      <WarningIcon sx={{ height: '22px', width: '22px' }} />
      <MUITypography variant="body1" sx={{ fontWeight: '600', color: '#A64200', mb: 0, flexGrow: '1', ml: 4 }}>
        {`New matters need approval`}
      </MUITypography>
      <MUIButton
        onClick={() => {
          setNotificationDrawerIsOpen(true)
          setNotificationTypeId('NEWMATTER')
          setNotificationSourceId('PERFECTPORTAL')

          fetchAllNotifications({
            notificationStatusIds: 'OPEN',
            startAtIndex: 0,
            pageSize: 25
          })
        }}
        sx={{ color: '#A64200', fontWeight: '600', textTransform: 'uppercase' }}
      >
        View all
      </MUIButton>
    </MUIStack>
  )
}

type ThirdPartyNotificationProps = {
  open: boolean
}
